export default [
  {
    path: '/',
    name: 'home',
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "dashboard" */ '@/pages/home/index')
  },
  {
    path: '/home/homeworks',
    name: 'home-homework',
    component: () =>
      import('@/pages/home/staff/components/homework-link-from-home.vue')
  },
  {
    path: '/home/my-approval-lists',
    name: 'home-my-approval-list',
    component: () =>
      import('@/pages/home/staff/components/my-approval-list.vue')
  },
  {
    path: '/teacher/homeworks',
    name: 'teacher-homework',
    component: () =>
      import('@/pages/home/teacher/components/homework-link-from-home.vue')
  },
  {
    path: '/student/homeworks',
    name: 'student-homework',
    component: () =>
      import('@/pages/home/student/components/homework-link-from-home.vue')
  },
  {
    path: '/home/my-request-lists',
    name: 'my-request-list',
    component: () =>
      import('@/pages/home/student/components/my-request-link-from-home.vue')
  },
  {
    path: '/home/my-request-edit-lists',
    name: 'my-request-edit-list',
    component: () =>
      import('@/pages/home/parent/components/my-request-link-from-home.vue')
  }
]
